/**
 * @generated SignedSource<<ac9ab0655f45be4f237fcd2406cfc637>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, GraphQLSubscription } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BuildStatusChipNewSubscription$variables = {
  buildID: string;
};
export type BuildStatusChipNewSubscription$data = {
  readonly build: {
    readonly " $fragmentSpreads": FragmentRefs<"BuildStatusChipNew_build">;
  } | null;
};
export type BuildStatusChipNewSubscription = {
  response: BuildStatusChipNewSubscription$data;
  variables: BuildStatusChipNewSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "buildID"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "buildID"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BuildStatusChipNewSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Build",
        "kind": "LinkedField",
        "name": "build",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "BuildStatusChipNew_build"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BuildStatusChipNewSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Build",
        "kind": "LinkedField",
        "name": "build",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasPausedTasks",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "86078d456798777c15943fc0a387ad0c",
    "id": null,
    "metadata": {},
    "name": "BuildStatusChipNewSubscription",
    "operationKind": "subscription",
    "text": "subscription BuildStatusChipNewSubscription(\n  $buildID: ID!\n) {\n  build(id: $buildID) {\n    ...BuildStatusChipNew_build\n    id\n  }\n}\n\nfragment BuildStatusChipNew_build on Build {\n  id\n  status\n  hasPausedTasks\n}\n"
  }
};
})();

(node as any).hash = "466ba8fed22f6714fb73e7a4ee400ccd";

export default node;
